import React from 'react';
//@ts-ignore
import { useBranch } from 'baobab-react/hooks';
// styled components
import { Loading, LoadingWrap } from '@styled/Basic';
export default function WidgetLoader(_a) {
    var wId = _a.wId, _b = _a.loading, loading = _b === void 0 ? false : _b;
    var widgetsLoading = useBranch({
        widgetsLoading: ['state', 'widgetsLoading'],
    }).widgetsLoading;
    if (widgetsLoading[wId] || loading) {
        return (React.createElement(LoadingWrap, { style: { borderRadius: '10px' }, "$dimBg": true, "$dimBgLight": true },
            React.createElement(Loading, { "$size": 2 })));
    }
    else {
        return null;
    }
}
